module.exports = __webpack_public_path__ + "static/c62201ca.banner_66.png";